import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// เปลี่ยนจาก import App from './App'; เป็น:
import App from './App.js'; 

// เปลี่ยนจาก import reportWebVitals from './reportWebVitals'; เป็น:
import reportWebVitals from './reportWebVitals.js';
import { installAuthFetchInterceptor } from './utils/authFetch.js';

installAuthFetchInterceptor();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
